import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class NewAutomationDialogAnalytics extends AnalyticsBase {
  public readonly namespace = `NewAutomationDialog`;
  public readonly requireViewContext = true;

  public trackNewAutomation(type: 'blank' | 'fromTemplate'): void {
    this.track('SelectOption', { type });
  }
}
